declare namespace $ {

	export class $shm_hitalama_map_widget_float_component extends $shm_hitalama_map_widget_float_code {
	}
	
}

//# sourceMappingURL=component.view.tree.d.ts.map